// @flow
/* eslint-disable camelcase */
import React from "react";
import FormField from "../components/FormField";
import KVForm from "./KVForm";
import "./stylesheets/Editor.scss";

type Props = {
  form: Object,
  keyValues: { keys: Array<string>, values: Array<string> },
  submitFormField: Function,
  updateKVKeys: Function,
  updateKVValues: Function,
  addEmptyKeyValue: Function,
  removeKeyValue: Function,
  disabled?: boolean
};

type State = {
  form: Object,
  keyValues: { keys: Array<string>, values: Array<string> }
};

class Editor extends React.Component<Props, State> {
  state: State = {
    form: this.props.form,
    keyValues: this.props.keyValues
  };

  componentWillReceiveProps(nextProps: Props) {
    const { form, keyValues } = nextProps;
    this.setState({
      form,
      keyValues
    });
  }

  onChangeForm = (formKey: string, value: string) => {
    this.props.submitFormField(formKey, value);
    this.setState({
      ...this.state,
      form: {
        ...this.state.form,
        [formKey]: value
      }
    });
  };

  render() {
    const {
      form: { title, body, deeplink, attachment_url },
      keyValues
    } = this.state;
    const {
      updateKVKeys,
      updateKVValues,
      addEmptyKeyValue,
      removeKeyValue,
      disabled = false
    } = this.props;
    return (
      <div className="Editor">
        <FormField
          title="TITLE"
          formKey="title"
          value={title}
          onChangeCallback={this.onChangeForm}
          disabled={disabled}
        />
        {/* // TODO Re-enable for v1
      <FormField
        title="SUBTITLE"
        formKey="subtitle"
        value={subtitle}
      />
      */}
        <FormField
          title="BODY"
          formKey="body"
          rows="4"
          value={body}
          onChangeCallback={this.onChangeForm}
          disabled={disabled}
        />
        <FormField
          title="RICH MEDIA EMBED"
          formKey="attachment_url"
          placeholder="JPG, GIF, PNG"
          value={attachment_url}
          onChangeCallback={this.onChangeForm}
          disabled={disabled}
        />
        <FormField
          title="DEEP LINKING"
          formKey="deeplink"
          placeholder="URL"
          value={deeplink}
          onChangeCallback={this.onChangeForm}
          disabled={disabled}
        />
        <KVForm
          keys={keyValues.keys}
          values={keyValues.values}
          updateKVKeys={updateKVKeys}
          updateKVValues={updateKVValues}
          addEmptyKeyValue={addEmptyKeyValue}
          removeKeyValue={removeKeyValue}
          disabled={disabled}
        />
      </div>
    );
  }
}

export default Editor;



// WEBPACK FOOTER //
// ./node_modules/@localytics/push-message-builder/src/components/Editor.jsx